import { render, staticRenderFns } from "./igM.vue?vue&type=template&id=33e92ba2&scoped=true"
import script from "./igM.vue?vue&type=script&lang=js"
export * from "./igM.vue?vue&type=script&lang=js"
import style0 from "./igM.vue?vue&type=style&index=0&id=33e92ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e92ba2",
  null
  
)

export default component.exports